import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  'x-smallTop': {
    paddingTop: theme.spacing.xSmall,
  },
  smallerTop: {
    paddingTop: theme.spacing.smaller,
  },
  smallTop: {
    paddingTop: theme.spacing.small,
  },
  mediumTop: {
    paddingTop: theme.spacing.medium,
  },

  'x-smallLeft': {
    paddingLeft: theme.spacing.xSmall,
  },
  smallerLeft: {
    paddingLeft: theme.spacing.smaller,
  },
  smallLeft: {
    paddingLeft: theme.spacing.small,
  },
  mediumLeft: {
    paddingLeft: theme.spacing.medium,
  },

  'x-smallRight': {
    paddingRight: theme.spacing.xSmall,
  },
  smallerRight: {
    paddingRight: theme.spacing.smaller,
  },
  smallRight: {
    paddingRight: theme.spacing.small,
  },
  mediumRight: {
    paddingRight: theme.spacing.medium,
  },

  'x-smallHorizontal': {
    paddingLeft: theme.spacing.xSmall,
    paddingRight: theme.spacing.xSmall,
  },
  smallerHorizontal: {
    paddingLeft: theme.spacing.smaller,
    paddingRight: theme.spacing.smaller,
  },
  smallHorizontal: {
    paddingLeft: theme.spacing.small,
    paddingRight: theme.spacing.small,
  },
  mediumHorizontal: {
    paddingLeft: theme.spacing.medium,
    paddingRight: theme.spacing.medium,
  },

  'x-smallVertical': {
    paddingTop: theme.spacing.xSmall,
    paddingBottom: theme.spacing.xSmall,
  },
  smallerVertical: {
    paddingTop: theme.spacing.smaller,
    paddingBottom: theme.spacing.smaller,
  },
  smallVertical: {
    paddingTop: theme.spacing.small,
    paddingBottom: theme.spacing.small,
  },
  mediumVertical: {
    paddingTop: theme.spacing.medium,
    paddingBottom: theme.spacing.medium,
  },

  'x-small': {
    padding: theme.spacing.xSmall,
  },
  smaller: {
    padding: theme.spacing.smaller,
  },
  small: {
    padding: theme.spacing.small,
  },
  medium: {
    padding: theme.spacing.medium,
  },
}));

export default useStyles;
